import { SentryReact } from "../../../index.js";
import {
	USED_CAR_DRAWER_OPEN_CLASS_NAME,
	USED_CAR_DRAWER_URL,
	USED_CAR_DRAWER_WIDTH,
} from "../const.js";

let previousScrollY = 0;

/**
 * Method to call when the used car drawer is going to be open.
 * @param setIsDrawerOpen — State setter keeping track whether
 * the used car drawer is open or not.
 * @param id — ID of the used car whose drawer is going to be open.
 */
export const onUsedCarDrawerOpen = (
	setIsDrawerOpen,
	id
) => {
	try {
		// Set the drawer open
		setIsDrawerOpen(true);

		// Save the current vertical position
		previousScrollY = window.scrollY;

		// Make the menu hidden and the webapp not
		// scrollable anymore
		document.body.classList.add(
			USED_CAR_DRAWER_OPEN_CLASS_NAME
		);
		document.documentElement.style.overflow =
			"var(--overflow-hidden)";
		document.body.style.overflow = "var(--overflow-hidden)";
		document.body.style.position = "var(--position-fixed)";
		document.body.style.top = "-" + previousScrollY + "px";
		document.body.style.width = USED_CAR_DRAWER_WIDTH;

		// Change the URL dynamically
		/* eslint-disable-next-line no-undef */
		globalThis.history.pushState(
			{ id: id },
			"",
			"/" + USED_CAR_DRAWER_URL + id
		);
	} catch (error) {
		// Log error with Sentry
		SentryReact.logger.error(error, {
			context: "Open used car drawer",
			carId: id,
		});
	}
};

/**
 * Method to call when the used car drawer is going to be closed.
 * @param setIsDrawerOpen — State setter keeping track whether
 * the used car drawer is open or not.
 */
export const onUsedCarDrawerClose = (setIsDrawerOpen) => {
	try {
		// Set the drawer closed
		setIsDrawerOpen(false);

		// Make the menu visible and the webapp
		// scrollable again
		document.body.classList.remove(
			USED_CAR_DRAWER_OPEN_CLASS_NAME
		);
		document.documentElement.style.overflow =
			"var(--overflow-auto)";
		document.body.style.overflow = "var(--overflow-auto)";
		document.body.style.position = "";
		document.body.style.top = "";
		document.body.style.width = "";

		// Restore vertical position
		window.scrollTo({
			top: previousScrollY,
			left: 0,
			behavior: "instant",
		});

		// Redirect the user to the 'UsedCars' section
		/* eslint-disable-next-line no-undef */
		globalThis.history.replaceState({}, "", "/");
	} catch (error) {
		// Log error with Sentry
		SentryReact.logger.error(error, {
			context: "Close used car drawer",
		});
	}
};
